import CardActions from '@material-ui/core/CardActions'

export default CardActions
